import { render } from "./customer.vue?vue&type=template&id=5d0c9cd3"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=5d0c9cd3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__